module.exports = __webpack_public_path__ + "static/media/JCoin.644b4e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/JCoin.png
// module id = 1530
// module chunks = 0